import {v4 as uuidv4} from 'uuid';
import {BlockType} from '../block';
import AiGraderBlock = App.Entities.Tasks.Ui.AiGraderBlock;
import AiGraderComponentGrader = App.Entities.Tasks.ComponentGraders.AiGraderComponentGrader;

export const aiGrader: BlockType<AiGraderBlock, AiGraderComponentGrader> = {
  translationKey: 'ai-grader',
  icon: 'creation',
  getName: (block) => block.name,
  sharedValues: [],
  uiConfigFactory: () => ({
    uuid: uuidv4(),
    type: 'AiGrader',
    name: 'Ai Grader',
    part: '',
    // Config
  }),
  componentGraderFactory: (uuid) => ({
    uuid: uuidv4(),
    type: 'AiGrader',
    name: 'Ai Grader',
    uiComponentUuid: uuid,
    // Config
    subject: '',
    instructions: '',
    contextBlockIds: [],
    markingExamples: [],
    criteriaList: [
      {
        name: '',
        instructions: '',
        points: 1,
        pointsIncrement: 0.05,
        passFailThreshold: null,
      },
    ],
  }),
};
